import { AppContent } from "twyne-new.ui";

export default function Sidebar({ children, size = '60', open, className }) {
  return <>
    <div className={`w-${size} twy-bg-base-accent rounded-xs ${open ? 'block' : 'hidden'} ${className || ''}`}>
      <div className='flex h-full'>
        <AppContent>
          <div className='p-2'>
            {children}
          </div>
        </AppContent>
      </div>
    </div>
  </>
}
